<template>
    <section :id="`element-${settings.id}`" class="elle-banner">
        <div class="container">
            <div class="content center">
                <div v-show="settings?.label" class="page-label light">{{ settings?.label }}</div>
                <div v-show="settings?.headline" class="page-title text-center uppercase color-white" v-html="nl2br(props.settings?.headline)" />
                <div v-if="settings?.linkUrl.length" class="page-buttons">
                    <UiLink :link="settings.linkUrl[0]" :style="'white'" />
                </div>
            </div>
        </div>
        <div class="elle-banner--media">
            <div
                v-if="settings?.media.length"
                class="media-image"
                :style="{
                    backgroundImage: `url(${settings?.media[0].webp})`
                }"
            />
            <video
                v-if="settings?.video.length"
                ref="$video"
                class="media-video"
                :poster="settings?.media[0].webp"
                playsinline
                loop
                muted
                preload="none"
            >
                <source :src="settings?.video[0].url" type="video/mp4" />
                Your browser doesn't support HTML5 video tag.
            </video>
        </div>
    </section>
</template>

<script setup lang="ts">
const { $ScrollTrigger: ScrollTrigger } = useNuxtApp();

const props = defineProps({
    settings: {
        type: Object,
        default: () => ({})
    }
});

const $video = ref<HTMLVideoElement | null>(null);
let videoTrigger: { kill: () => void; isActive: boolean } | null = null;

const playVideo = () => {
    const video = $video.value;
    if (!video) {
        return;
    }

    const playPromise = video.play();
    if (playPromise && typeof playPromise.catch === 'function') {
        playPromise.catch(() => undefined);
    }
};

const pauseVideo = () => {
    $video.value?.pause();
};

onMounted(() => {
    if (!ScrollTrigger || !$video.value) {
        return;
    }

    videoTrigger = ScrollTrigger.create({
        trigger: $video.value,
        start: 'top bottom',
        end: 'bottom top',
        onEnter: playVideo,
        onEnterBack: playVideo,
        onLeave: pauseVideo,
        onLeaveBack: pauseVideo
    });

    if (videoTrigger.isActive) {
        playVideo();
    } else {
        pauseVideo();
    }
});

onBeforeUnmount(() => {
    videoTrigger?.kill();
});
</script>
